module.exports = __webpack_public_path__ + "static/media/address-book.fe2477cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/address-book.svg
// module id = 2246
// module chunks = 7